/**
 *  initiate skrollr for parallax effect
 */
import skrollr from 'skrollr';

const parallaxArea = function () {
  const $parallax = $('.parallax');

  if ($parallax.length === 0) return;

  // initiate skrollr
  skrollr.init({
    forceHeight: false
  });
};

export { parallaxArea };
